import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";

import Navbar from "./component/Navbar/navbar";
import Footer from "./component/Footer/Footer";
import ScrollToTop from "./component/ScrollToTop/ScrollToTop";
import Home from "./component/Home/Home";
import FullAbout from "./component/About/FullAbt";
import FullServices from "./component/Services/Services";
import FinanceDetail from "./component/Services/Finance/Finance";
import ProjectDevelopment from "./component/Services/Project/Project";
import EPCDetail from "./component/Services/EPC/EPC";
import EmergingDetail from "./component/Services/Emerging/Emerging";
import FullTeam from "./component/FullTeam/FullTeam";
import Careers from "./component/Carrier/Carrier";
import SolarProjectDetail from "./component/SolarProjectDetail/SolarProjectDetail";
import Contact from "./component/Contact/Contact";
import SolarIPP from "./component/SolarIPP/SolarIPP";
import SolarEPC from "./component/SolarEPC/SolarEPC";
import SolarHybrid from "./component/SolarHybrid/SolarHybrid";
import SolarBESS from "./component/SolarBESS/SolarBESS";

function App() {
  return (
    <Router>
      <div className="app-container">
        {/* ScrollToTop must stay inside Router to work */}
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<FullAbout />} />
          <Route path="/services" element={<FullServices />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/fullteam" element={<FullTeam />} />
          <Route path="/contact" element={<Contact />} />

          {/* Career Path */}
          <Route path="/careers/solar-engineer" element={<SolarProjectDetail />} />

          {/* Sub-Service Routes */}
          <Route path="/services/finance" element={<FinanceDetail />} />
          <Route path="/services/project-development" element={<ProjectDevelopment />} />
          <Route path="/services/epc-coordination" element={<EPCDetail />} />
          <Route path="/services/emerging" element={<EmergingDetail />} />

          {/* Project Routes */}
          <Route path="/projects/solar-ipp" element={<SolarIPP />} />
          <Route path="/projects/solar-epc" element={<SolarEPC />} />
          <Route path="/projects/solar-hybrid" element={<SolarHybrid />} />
          <Route path="/projects/solar-bess" element={<SolarBESS />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;